var _styled;

import styled from 'react-emotion';
import { MEDIA_QUERIES, SPACING } from '@govuk-react/constants';
var SearchWrapper = styled('div')((_styled = {
  marginTop: SPACING.SCALE_1,
  width: '50%',
  minWidth: '110px'
}, _styled[MEDIA_QUERIES.LARGESCREEN] = {
  width: '100%'
}, _styled));
export default SearchWrapper;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/top-nav/es/atoms/search-wrapper/index.js
// module id = 115
// module chunks = 0